export const signupEp = ()=>{
return("/api/user/register")
}